import Vue from "vue";
import Vuex from "vuex";

import users from "@/assets/json/users.json";
import shoes from "@/assets/json/shoes.json";
import faq from "@/assets/json/faq.js";
import winners from "@/assets/json/winners.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    display: {
      modalIsOpen: false,
      bodyNoScroll: false,
      popinError: false
    },
    auth: {
      isConnected: false,
      user: {},
      shoe: ""
    },
    users: JSON.parse(JSON.stringify(users)),
    shoes: JSON.parse(JSON.stringify(shoes)),
    faq: faq,
    winners: JSON.parse(JSON.stringify(winners)),
    stripe: {
      publishableKey: "pk_live_lk31y9rO7u3SaDme70VH4G3B00K1cfrhMr",
      items: [
        {
          plan: "plan_GtyLwvZma2O7Kg",
          quantity: 1
        }
      ],
      successUrl: "https://sneakbox.netlify.com/validation",
      cancelUrl: "https://sneakbox.netlify.com/"
    }
  },
  getters: {
    getUserByMail: state => mail => {
      return state.users.find(user => user.mail === mail);
    },
    getWinnerByMail: state => mail => {
      return state.winners.find(winner => winner.mail === mail);
    },
    isUserExist: state => mail => {
      return state.users.find(user => user.mail === mail) !== undefined;
    },
    getShoeById: state => shoeId => {
      return state.shoes.find(shoe => shoe.id === shoeId);
    },
    getUserOnStorage: () => {
      return localStorage.getItem("snkbx-beta-mail");
    },
    getErrorOnStorage: () => {
      return localStorage.getItem("snkbx-beta-err");
    }
  },
  mutations: {
    updateIsConnected: (state, boolean) => {
      state.auth.isConnected = boolean;
    },
    updateModalIsOpen: (state, boolean) => {
      state.display.modalIsOpen = boolean;
    },
    updateBodyNoScroll: (state, boolean) => {
      state.display.bodyNoScroll = boolean;
    },
    updatePopinError: (state, boolean) => {
      state.display.popinError = boolean;
    },
    updateUser: (state, object) => {
      state.auth.user = object;
    },
    updateUserShoe: (state, string) => {
      state.auth.shoe = string;
    }
  },
  actions: {
    saveUserOnStorage: ({ state }) => {
      const mail = state.auth.user.mail;
      if (mail !== undefined) {
        localStorage.setItem("snkbx-beta-mail", mail);
      } else {
        console.error("Can't save email on browser");
      }
    },
    saveErrorStorage: () => {
      localStorage.setItem("snkbx-beta-err", "true");
    }
  },
  modules: {}
});
